import { render, staticRenderFns } from "./RightShipQuestionnaires.vue?vue&type=template&id=7ff586d8&scoped=true&"
import script from "./RightShipQuestionnaires.vue?vue&type=script&lang=js&"
export * from "./RightShipQuestionnaires.vue?vue&type=script&lang=js&"
import style0 from "./RightShipQuestionnaires.vue?vue&type=style&index=0&id=7ff586d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff586d8",
  null
  
)

export default component.exports